import GeoBase, {IGeoParams} from './geo_base';
import GeoDataFormater from "./geo_data_formatter";
import {GEO_LOCATION} from "./geo_consts";
import Event from "../../utils/event";
import {SYSTEM_EVENTS} from "../../events/events";

export interface IOobeeParams extends IGeoParams{
    oobeeLib:string;
    jqueryLib:string;
    serviceURL:string;
    oobeeURL:string;
    iosInstallURL:string;
}
const RETRY_ERROR:number[] = [99,100,131,173,301,600];
const MAX_ERROR_TRIES:number  = 3;

export default class GeoOobee extends GeoBase {

    static CLASS:string = 'GeoOobee';
    private geo = null;
    private geoLocationReject:Function = this.doFailGeoLocation;
    private geoLocationResolve:Function;
    protected initParams:IOobeeParams;
    private serviceURL:string;
    private oobeeURL:string;
    private errorTryNumber:number = 0;
    private gotHint:boolean = false;
    private needToResendOnGettingFocus:boolean = false;

    protected init(params:IOobeeParams) : void {
        super.init(params);
        this.serviceURL = params.serviceURL;
        this.oobeeURL = params.oobeeURL;
    }

    public runWrapper():void {
        let http2Service = this.parent.getServiceFactory().http2Service();
        let loadScriptJS = this.parent.getServiceFactory().scriptLoaderService().loadScript;
        loadScriptJS(http2Service.originReplacer(this.initParams.jqueryLib))
            .then(() => loadScriptJS(http2Service.originReplacer(this.initParams.oobeeLib)))
            .then(() => this.initGC())
            .catch(() => this.sendAnalytics('Oobee JS is not available'));
        Event.on(SYSTEM_EVENTS.APP_RESUMED, this.tryToResendDataOnGettingFocus, this);
    }

    public isPlugInEnable(bMandatory:boolean):Promise<boolean> {
        //if it true ->return Promise.resolve
        //if not -> return new Promise - that never happens
        if(bMandatory){
            this.sendAnalytics('isPlugInEnable true');
            return Promise.resolve(true);
        }
        this.sendAnalytics('isPlugInEnable Promise');
        return new Promise(() => {});
    }

    public getGeoLocation(data:GeoDataFormater):Promise<void> {
        let error:string = this.setGeoParams(data);
        this.sendAnalytics('setGeoParams ' + error);
        this.errorTryNumber = 0;
        return this.requestGeolocation();
    }

        private initGC():void {
                if (!this.geo) {
                this.geo = (window as any).GCOobee.createClient();
                this.geo.events
                    .on('**', function() {
                        console.log('oobeeLog: ' + this.event)
                    })
                    .on('before', () => {
                        this.sendAnalytics('before');
                        //on starting
                    })
                    .on('log', () => {
                        this.sendAnalytics('log');
                        //for logging purpose
                    })
                    .on('init.failed', (code, message) => {
                        this.geoLocationReject(code, message);
                        this.sendAnalytics('init.failed ' + code + ' ' + message);
                        //called when any errors occur while initializing (e.g. network issue, invalid or expired license, other geolocating is in process)
                    })
                    .on('init.success', () => {
                        this.sendAnalytics('init.success');
                        //Called when no errors occur while initializing, it's ready for geolocating
                    })
                    .on('register.start', () => {
                        this.sendAnalytics('register.start');
                        //Called when start device registering
                    })
                    .on('register.failed', (code, message) => {
                        this.sendAnalytics('register.failed ' + code + ' ' + message);
                        this.geoLocationReject(code, message);
                        //Called when any errors occur while registering the device
                    })
                    .on('register.success', () => {
                        this.sendAnalytics('register.success');
                        //Called when device is registered successfully
                    })
                    .on('geolocation.start', () => {
                        this.sendAnalytics('geolocation.start');
                        //Called when start geolocating
                    })
                    .on('geolocation.failed', (code, message) => {
                        this.sendAnalytics('geolocation.failed ' + code + ' ' + message);
                        this.geoLocationReject(code, message);
                        //Called when any errors occur while geolocating
                    })
                    .on('geolocation.success', (data) => {
                        this.sendAnalytics('geolocation.success ' + data);
                        this.geoLocationResolve(data);
                        //Called when geolocating is done
                    })
                    .on('hint', (data) => {
                        this.sendAnalytics('hint' + data ? data.message : '');
                        this.showHintMSG(data)
                            .then(result => {
                                this.needToResendOnGettingFocus = result;
                            });
                    });
            }
        }

        private showHintMSG(msg:any):Promise<boolean> {
            this.parent.closeFreezeWindow();
            this.sendAnalytics('showHintMSG');
            let languageService = this.parent.getServiceFactory().languageService();
            this.gotHint = true;
            return new Promise((resolve) => {
                let msgTxt = msg.message + '<br><br>'+languageService.translation(GEO_LOCATION.OOBEE_HINT_TXT);
                let installUrl, wakeupUrl;
                if ((window as any).GCOobee.utils.browser.is.android){
                    installUrl = msg.androidWakeupIntent;
                    wakeupUrl = msg.androidWakeupUrl;
                    this.needToResendOnGettingFocus = true;
                } else {
                    installUrl = this.initParams.iosInstallURL;
                    wakeupUrl = msg.iosWakeupUrl;
                }
                    let options = {
                    hasImage: false,
                    text: msgTxt,
                    closeButton: true,
                    title: languageService.translation(GEO_LOCATION.OOBEE_HINT_TITLE),
                    buttons: [
                        {name: languageService.translation(GEO_LOCATION.OOBEE_HINT_INSTALL), isClosable: true, callback: () => {
                                this.sendAnalytics('Install Clicked');
                                this.parent.getServiceFactory().windowService().openInNewWindow(installUrl);
                                this.gotHint = false;
                                resolve(true);
                            }},
                        {name: languageService.translation(GEO_LOCATION.OOBEE_HINT_WAKEUP), isClosable: true, callback: () => {
                                this.sendAnalytics('WakeUp Clicked');
                                this.parent.getServiceFactory().windowService().openInNewWindow(wakeupUrl);
                                this.gotHint = false;
                                resolve(true);
                            }}
                    ],
                    btnCloseCallback: () => {
                        this.sendAnalytics('Install Closed');
                        this.parent.closeFreezeWindow();
                        resolve(false);
                    }
                };
                this.parent.getServiceFactory().messageManagerService().openMessage(options);
            });
        }

        private setGeoParams(data:GeoDataFormater):string {
            let oobeeConfiguration = {
                serviceUrl: this.serviceURL,
                oobeeUrl: this.oobeeURL,
                //enablePlayStorePopUp: true,
                //geoTimeout: '...',
                //pemTimeout: '...',
                //enableAndroidSimplified: true,
                license: data.license,
                userId: data.userId,
                reason: this.getOobeeReason(data.reason),
                phone: data.phone,
                session: data.sessionKey,//TODO check if needed
                customFields: {session_key: data.sessionKey}
            };
            return this.geo.configure(oobeeConfiguration);
        }

        private getOobeeReason(reason:string):string{
                let ret:string;
                switch (reason.toLowerCase()) {
                    case 'login':
                        ret = 'SessionStart';
                        break;
                    default:
                        ret = 'SessionIntervalGeo';
                        break;
                }
                return ret;
            }

        private requestGeolocation():Promise<void> {
            this.errorTryNumber ++;
            this.parent.restartFreezeWindowIfNeeded();
            this.needToResendOnGettingFocus = false;
            this.sendAnalytics('requestGeolocation');
            return this.doGeoLocation()
                .then((res:string) => this.doPassGeoLocation(res))
                .catch((errorCode:number) => {
                    this.doFailGeoLocation(errorCode);
                    throw errorCode;
                })
        }

         private connect() {
            let oobee = this.geo;
            oobee.connect({
                timeout: 15000,
                userAction: true
            }, function() {
                oobee.request();
            }, function() {
                //ask user to open the app
                //Wait for HINT event
            });
        }

        private doGeoLocation():Promise<string> {
            return new Promise((resolve, reject) => {
                 this.geoLocationResolve = resolve;
                 this.geoLocationReject = reject;
                 if ((window as any).GCOobee.utils.browser.is.android) {
                    this.connect();
                 } else {
                     if (!this.geo.hasRegisteredRecently()) {
                          this.connect();
                     } else {
                        this.geo.request();
                     }
                 }
                 this.geo.request();
            });
        }

        private doPassGeoLocation(data:string):void {
                this.sendAnalytics('doPassGeoLocation');
            this.parent.onGeoLocationResOk(data);
        }

        private doFailGeoLocation(errorCode:number, errorMessage:string=''):void {
                this.sendAnalytics('doFailGeoLocation ' + this.gotHint + "-" + errorCode + "-" + errorMessage + "-" + this.errorTryNumber);
            if (this.gotHint){
                //ignore
            } else if (RETRY_ERROR.indexOf(errorCode) > -1 && this.errorTryNumber <= MAX_ERROR_TRIES){
                this.requestGeolocation();
            } else {
                this.parent.onGeoLocationResFailed(errorCode, errorMessage);
            }
        }

        protected sendAnalytics(action:string, additionalData:any=null):void {
                super.sendAnalytics(action, additionalData);
        }

        private tryToResendDataOnGettingFocus() {
            this.sendAnalytics('tryToResendDataOnGettingFocus ' + this.needToResendOnGettingFocus);
            if (this.needToResendOnGettingFocus){
                this.requestGeolocation();
            }
        }
    }
